module.exports = __webpack_public_path__ + "media/images/gift-thanks-modal-bg-onigiri@2x-a26eb8f28af25b33846bb66a1b673759.png";